import moment from 'moment'
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DataTable } from '../widgets';
import { DataTableRecordsNotFound } from '../widgets/DataTable';
import { groupBy } from '../../helpers/common';

const TripHistorySummary = ({ data, timezoneIdentifier }) => {
    const [tripByDate, setTripByDate] = useState([]);
    const [tripByReg, setTripByReg] = useState([]);

    useEffect(() => {
        const tripByDate = [];
        const tripByReg = [];

        const eventData = data.map((e) => {
            e["exitMapped"] = moment(e.exit).tz(timezoneIdentifier).format("YYYY-MM-DD");
            return e;
        });

        const exitGrouped = groupBy("exitMapped")(eventData);
        const regGrouped = groupBy("regionName")(eventData);

        for (const date of Object.keys(exitGrouped)) {
            tripByDate.push({
                date: date,
                trip: exitGrouped && exitGrouped[date] ? exitGrouped[date].length : 0
            })
        }
        for (const reg of Object.keys(regGrouped)) {
            tripByReg.push({
                region: reg,
                trip: regGrouped && regGrouped[reg] ? regGrouped[reg].length : 0
            })
        }
        setTripByDate(tripByDate);
        setTripByReg(tripByReg);
    }, [data]);

    return (
        <Row>
            <Col md={6}>
                <div className='title text-center' ><b>Total Trips for the Region</b></div>
                <DataTable className='mt-2 mb-5' striped bordered hover>
                    <DataTable.Header>
                        <DataTable.Row>
                            <DataTable.Cell width="30px" className="sort-column">#</DataTable.Cell>
                            <DataTable.Cell width="300px" className="sort-column">Region Name</DataTable.Cell>
                            <DataTable.Cell width="300px" className="sort-column">Trips</DataTable.Cell>
                        </DataTable.Row>
                    </DataTable.Header>
                    <DataTable.Body>
                        {
                            tripByReg.map((data, index) => (
                                <DataTable.Row key={index}>
                                    <DataTable.Cell>{index + 1}</DataTable.Cell>
                                    <DataTable.Cell>{data.region}</DataTable.Cell>
                                    <DataTable.Cell>{data.trip}</DataTable.Cell>
                                </DataTable.Row>
                            ))
                        }

                    </DataTable.Body>
                </DataTable>
                {tripByReg.length === 0 && <DataTableRecordsNotFound />}
            </Col>
            <Col md={6}>
                <div className='title text-center' ><b>Total Trips for the Day</b></div>
                <DataTable className='mt-2 mb-5' striped bordered hover>
                    <DataTable.Header>
                        <DataTable.Row>
                            <DataTable.Cell width="30px" className="sort-column">#</DataTable.Cell>
                            <DataTable.Cell width="300px" className="sort-column">Date</DataTable.Cell>
                            <DataTable.Cell width="300px" className="sort-column">Trips</DataTable.Cell>
                        </DataTable.Row>
                    </DataTable.Header>
                    <DataTable.Body>
                        {tripByDate.map((data, index) => (
                            <DataTable.Row key={index}>
                                <DataTable.Cell>{index + 1}</DataTable.Cell>
                                <DataTable.Cell>{moment(data.date).format("DD MMM YYYY")}</DataTable.Cell>
                                <DataTable.Cell>{data.trip}</DataTable.Cell>
                            </DataTable.Row>
                        ))}
                    </DataTable.Body>
                </DataTable>
                {tripByDate.length === 0 && <DataTableRecordsNotFound />}
            </Col>
        </Row>
    )
}

export default TripHistorySummary;